module.exports = __webpack_public_path__ + "static/media/cellphone-icon.5b5e3dbc.svg";